import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { LocalStorageKeys } from '@/constants/LocalStorage';

type AuthTokenState = {
  authToken: string | null;
  setAuthToken: (value: string | null) => void;
  removeAuthToken: () => void;
  reset: () => void;
};

const initialState = {
  authToken: null,
} satisfies Partial<AuthTokenState>;

export const useAuthTokenStore = create<AuthTokenState>()(
  persist(
    set => ({
      ...initialState,
      setAuthToken: value => set({ authToken: value }),
      removeAuthToken: () => set({ authToken: null }),
      reset: () => set(initialState),
    }),
    { name: LocalStorageKeys.AUTH_STORE },
  ),
);

export const useAuthToken = () => useAuthTokenStore(state => state.authToken);

export const useAuthTokenActions = () => {
  const setAuthToken = useAuthTokenStore(state => state.setAuthToken);
  const removeAuthToken = useAuthTokenStore(state => state.removeAuthToken);

  return {
    setAuthToken,
    removeAuthToken,
  };
};
